<template>
  <div v-if="componentLoader" class="position-relative h-100">
    <app-overlay-loader />
  </div>
  <div v-else>
    <app-overlay-loader v-if="preloader" />
    <div class="company_detail_info">
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
    <!-- <div class="row my-3" v-if="publicUrl == true">
      <div class="col-sm-12">
        <a :href="'/company/' + companyid" target="_blank">
          View company profile
        </a>
      </div>
    </div> -->
    <!-- <div class="row" v-if="showLink == true">
      <div class="col-sm-12">
        <button class="btn btn-primary" @click.prevent="companylogo">
          Generate company link
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { UserMixin } from "./Mixins/UserMixin";
import * as actions from "../../../Config/ApiUrl";
import AppLibrary from "../../../Helpers/AppLibrary";
// import { COMPANY_PROFILE_DETAIL } from "../../../../Config/ApiUrl";

export default {
  name: "CompanyInformation",
  extends: AppLibrary,
  mixins: [FormMixin, UserMixin, GlobalHelperMixin],
  data() {
    return {
      showLink: false,
      publicUrl: false,
      companyurl: [],
      companyid: "",
      // companydata:[],
      allMenu: false,
      fullScreen: false,
      leftMenuType: "normal",
      darkMode: false,
      icon: "settings",
      tabsHorizontal: [
         {
          name: "Company Info",
          component: "company-info",
          permission: "",
        },
        {
          name: "Logo",
          component: "company-logo",
          permission: "",
          // props:{

          //   companydata:[this.companydata]
          // },
        },
        {
          name: "Banner",
          component: "company-banner",
          permission: "",
        },
        {
          name: "Galleries",
          component: "company-gallery",
          permission: "",
        },
        {
          name: "About",
          component: "company-about",
          permission: "",
        },
        {
          name: "Organogram",
          component: "company-organogram",
          permission: "",
        },
      ],
      preloader: false,
      genderList: [
        {
          id: "male",
          value: "Male",
        },
        {
          id: "female",
          value: "Female",
        },
      ],
    };
  },
  methods: {
    beforeSubmit() {
      this.scrollToTop(true);
      this.preloader = true;
    },
    companylogo() {
      // let companylink;
      // let compnanyid;
      // let id = this.$attrs['props'];
      // this.companyid = id.companyId;
      // this.publicUrl = true;

      this.preloader = true;
      let url = actions.COMPANY_PROFILE_DETAIL;
      this.axiosGet(url)
        .then((response) => {
          this.companyurl = response.data.data;
          this.companyname = response.data.company_name;
          this.companyid = response.data.data.id;
          this.publicUrl = true;
          this.preloader = true;
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    submit() {
      let submitData = this.user.loggedInUser;
      if (submitData.date_of_birth)
        submitData.date_of_birth = this.getDateFormatForBackend(
          submitData.date_of_birth
        );
      else submitData.date_of_birth = null;
      this.save(submitData);
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      window.location = actions.MY_PROFILE;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
  },
  mounted() {
    var url = window.location.pathname;
    var profileType = url.substring(url.lastIndexOf("/") + 1);
      if(profileType == 'my-profile') {
        this.showLink = true;
      }
  },
};
</script>
